export class BackupPostureControl {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "Severity",
            "format": ""
        },
        {
            "name": "resourceSelector",
            "baseName": "resourceSelector",
            "type": "BackupPostureControlResourceSelector",
            "format": ""
        },
        {
            "name": "rules",
            "baseName": "rules",
            "type": "BackupPostureControlRules",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPostureControl.attributeTypeMap;
    }
    constructor() {
    }
}
